"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const Field_AutoSizeTextArea_1 = __importDefault(require("../utils/Field.AutoSizeTextArea"));
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Submit_1 = require("../utils/Field.Submit");
const FieldTextArea = ({ props }) => {
    const isDisabled = typeof props.disabled === type_1.TYPE_FUNCTION
        ? props.disabled(props)
        : props.disabled;
    if (props === null || props === void 0 ? void 0 : props.autoScale) {
        (0, Field_AutoSizeTextArea_1.default)(props.reference.current, props.value);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("textarea", { onKeyPress: (event) => {
                if (props.onKeyPress) {
                    props.onKeyPress({
                        event,
                        value: props.value,
                        data: (0, Field_Submit_1.FunctionGetValueFromFieldReference)(props.fields, props.FieldReference),
                        props,
                    });
                }
            }, ref: props.reference, id: props.name, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                ? props.classNameInput(props)
                : props.classNameInput}`, disabled: isDisabled, value: props.value, name: props.name, placeholder: props.placeholder, onChange: (e) => {
                const value = e.target.value;
                props.setValue(value);
            } })));
};
exports.default = FieldTextArea;
